import { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

export default function AdminDemoRequests() {
  const [tab, setTab] = useState('demo');
  const [requests, setRequests] = useState([]);
  const [subscribers, setSubscribers] = useState([]);
  const [unread, setUnread] = useState(0);

  useEffect(() => { fetchAll(); }, []);

  const fetchAll = async () => {
    try {
      const [d, n] = await Promise.all([
        api.get('/contact/demo-requests'),
        api.get('/contact/newsletter'),
      ]);
      setRequests(d.requests || []);
      setUnread(d.unread || 0);
      setSubscribers(n.subscribers || []);
    } catch { toast.error('Yüklenemedi'); }
  };

  const markRead = async (id) => {
    try {
      await api.patch(`/contact/demo-requests/${id}/read`);
      setRequests(prev => prev.map(r => r.id === id ? { ...r, isRead: true, readAt: new Date().toISOString() } : r));
      setUnread(prev => Math.max(0, prev - 1));
    } catch { toast.error('Hata'); }
  };

  return (
    <div style={{ padding: 28 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>Demo Talepleri</h1>
      <p style={{ color: '#64748b', fontSize: 13, marginBottom: 20 }}>Landing page üzerinden gelen demo istekleri ve bülten aboneleri.</p>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '2px solid #e2e8f0' }}>
        {[
          { id: 'demo',       label: `📩 Demo Talepleri${unread > 0 ? ` (${unread} yeni)` : ''}` },
          { id: 'newsletter', label: `📧 Bülten Aboneleri (${subscribers.length})` },
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: '8px 16px', border: 'none', background: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: 500,
            color: tab === t.id ? '#3b82f6' : '#64748b',
            borderBottom: tab === t.id ? '2px solid #3b82f6' : '2px solid transparent',
            marginBottom: -2,
          }}>{t.label}</button>
        ))}
      </div>

      {/* Demo Talepleri */}
      {tab === 'demo' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {requests.length === 0 && (
            <div style={{ textAlign: 'center', color: '#94a3b8', padding: 40 }}>Henüz demo talebi yok.</div>
          )}
          {requests.map(r => (
            <div key={r.id} className="card" style={{ padding: '16px 20px', borderLeft: r.isRead ? undefined : '3px solid #6366f1' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>
                    {r.name}
                    {!r.isRead && <span style={{ marginLeft: 8, fontSize: 11, background: '#6366f1', color: '#fff', padding: '2px 7px', borderRadius: 99 }}>Yeni</span>}
                  </div>
                  <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>
                    <a href={`mailto:${r.email}`} style={{ color: '#6366f1' }}>{r.email}</a>
                    {r.phone && ` · ${r.phone}`}
                    {r.company && ` · ${r.company}`}
                  </div>
                  <div style={{ fontSize: 13, color: '#1e293b', marginTop: 8, whiteSpace: 'pre-wrap', background: '#f8fafc', borderRadius: 8, padding: '8px 12px' }}>
                    {r.message}
                  </div>
                  <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 6 }}>
                    {format(new Date(r.createdAt), 'd MMMM yyyy HH:mm', { locale: tr })}
                    {r.isRead && r.readAt && ` · Okundu: ${format(new Date(r.readAt), 'd MMM HH:mm', { locale: tr })}`}
                  </div>
                </div>
                {!r.isRead && (
                  <button className="btn btn-secondary" style={{ fontSize: 12, padding: '6px 12px', whiteSpace: 'nowrap' }} onClick={() => markRead(r.id)}>
                    ✓ Okundu işaretle
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Bülten Aboneleri */}
      {tab === 'newsletter' && (
        <div>
          {subscribers.length === 0 && (
            <div style={{ textAlign: 'center', color: '#94a3b8', padding: 40 }}>Henüz abone yok.</div>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {subscribers.map(s => (
              <div key={s.id} className="card" style={{ padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 13 }}>{s.email}</span>
                <span style={{ fontSize: 11, color: '#94a3b8' }}>{format(new Date(s.createdAt), 'd MMM yyyy', { locale: tr })}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
